import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { captureKioskEntry } from './app/core/kiosk-session';

// Before routing, which drops the kiosk QR's query string.
captureKioskEntry();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
